export default __webpack_public_path__ + "static/media/sprayer.b02d77f3.png";